export default __webpack_public_path__ + "static/media/group03.11dd9150.svg";